import { render, staticRenderFns } from "./teacherDetail.vue?vue&type=template&id=666323d0&"
import script from "./teacherDetail.vue?vue&type=script&lang=js&"
export * from "./teacherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports